import { createFrontendModule, fetchApiRef } from '@backstage/frontend-plugin-api';
import { AnalyticsImplementationBlueprint } from '@backstage/plugin-app-react';
import { UsageAnalyticsClient } from './UsageAnalyticsClient';

const usageAnalytics = AnalyticsImplementationBlueprint.make({
  name: 'usage-analytics',
  params: define =>
    define({
      deps: { fetchApi: fetchApiRef },
      factory: ({ fetchApi }) => new UsageAnalyticsClient(fetchApi),
    }),
});

export const usageAnalyticsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [usageAnalytics],
});
